import React from 'react'

import styled from 'styled-components'

const DropProgress = ({
  active,
  value,
  postActive,
  last,
  text,
  onSetStep,
  disabled,
}) => {
  return (
    <StyledProgress as="button" disabled={disabled} last={last}>
      <div
        onClick={() => !disabled && onSetStep(value)}
        className={
          active
            ? 'circle-dot active'
            : postActive
            ? 'circle-dot postActive'
            : 'circle-dot'
        }
      />
      <p>{text}</p>
    </StyledProgress>
  )
}

export const StyledProgress = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  background: none;
  outline: none;
  border: none;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .circle-dot {
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
    background: #e9ebf2;
    position: relative;
    margin-bottom: 2.5rem;
    cursor: pointer;

    @media (max-width: 768px) {
      margin-bottom: 0.7rem;
    }

    &:after {
      content: '';
      width: 1px;
      height: 2.5rem;
      background: #e9ebf2;
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      display: ${(p) => (p.last ? 'none' : 'block')};

      @media (max-width: 768px) {
        display: none;
      }
    }

    &.active {
      background: #ff5880;

      &:after {
        background: #ff5880;
      }
    }

    &.postActive {
      border: 1px solid #ff5880;
      background: #fff;

      &:after {
        background: #ff5880;
      }
    }
  }

  p {
    font-size: 0.75rem;
    font-weight: 300;
    margin-left: 2rem;

    @media (max-width: 768px) {
      text-align: center;
      margin-left: 0;
      padding: 0.5rem;
    }
  }
`

export default DropProgress
